import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/park/tempcar/feerule/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/park/tempcar/feerule/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/park/tempcar/feerule/remove', qs.stringify(params),options);

export const syncFeeRule = (params, options) =>
request.post('/api/v4ward/park/tempcar/feerule/sync', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/park/tempcar/feerule/submit', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/park/tempcar/feerule/submit', params,options);

export const test = (params, options) =>
  request.post('/api/v4ward/park/tempcar/feerule/test', params,options);
